(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    

  // Update quantity in form in mobile view
  function initCartPage(){
    var qtySmall = document.querySelectorAll('input[id^=qty_]')
    
    qtySmall.forEach(function(el){
      el.addEventListener('change', function(e){
        var index = parseInt(e.target.dataset.quantityIndex)
        var qtyLarge = document.querySelector('input[data-quantity-item="' + index +'"]')
        qtyLarge.value = e.target.value
      })
    })
  }

  document.addEventListener("DOMContentLoaded", initCartPage);
  document.addEventListener("shopify:section:load", initCartPage);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"]) return;
  try {
    
  
  function initCollage(){

    // Toggle caption on hover
    var images = document.querySelectorAll('.collage-block * > img, .collage-block .video-wrapper')
    
    images.forEach(function(img){
      img.addEventListener('mouseenter', function(e){
        var caption = e.target.closest('.collage-block').querySelector('.collage-block-caption')
        if(caption)
          caption.classList.add('collage-block-caption-show')
      })
      img.addEventListener('mouseleave', function(e){
        var caption = e.target.closest('.collage-block').querySelector('.collage-block-caption')
        if(caption)
          caption.classList.remove('collage-block-caption-show')
      })
    })
  }
  document.addEventListener("DOMContentLoaded", initCollage);
  document.addEventListener("shopify:section:load", initCollage);
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ddp-banner"]) return;
  try {
    

  function initBanner(){
    
    //Cookies.remove('ddp-banner-shown');
    const wasShown = Cookies.get('ddp-banner-shown');
    const banner = document.querySelector('#ddp-banner');
    
    if(!banner) return
    
    if(!wasShown){
      banner.classList.add('ddp-show');
    }

    const close = document.querySelector('#ddp-banner .ddp-close');
    
    close.addEventListener('click', function(){
      
      banner.classList.remove('ddp-show');
      banner.classList.add('ddp-hide');
      Cookies.set('ddp-banner-shown', true);
    });
    
  }

  document.addEventListener("DOMContentLoaded", initBanner);
  document.addEventListener("shopify:section:load", initBanner);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  function initFooter(){
    var contactForm = document.getElementById('contact_form')
    var contactFormSubmit = document.getElementById('contact_form_submit')
    
    contactFormSubmit.addEventListener('click', function(e){
      contactForm.submit()
    })
  }

  document.addEventListener("DOMContentLoaded", initFooter);
  document.addEventListener("shopify:section:load", initFooter);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"]) return;
  try {
    

  // Hide splash when coming from other url on site
  function initHomePage(){
    var banner = document.querySelector('.banner')
    var bannerImage = document.getElementById('banner-box-image')
    var main = document.querySelector('main')
    var menu = document.getElementById('menu')
    
    if(document.referrer && performance.navigation.type !== performance.navigation.TYPE_RELOAD){
      banner.style.display = 'none'
    }else{
      menu.classList.add('menu-hidden');
      main.classList.add('main-intro');
      
      function handleClick(){ 
        console.log('handle click')
        if(banner.classList.contains('banner-slideup')) 
          return
        window.scrollTo(0,0);
        main.classList.add('main-slideup');
        banner.classList.add('banner-slideup');
        menu.classList.add('menu-show'); 
      }

      banner.addEventListener('click', handleClick)
      banner.addEventListener('touchstart', handleClick)

      if(bannerImage.complete) 
        return setTimeout(handleClick, 1500)

      bannerImage.addEventListener('load', function(){
        console.log('loaded banner')
        setTimeout(handleClick, 1500)
      })
    }
  }

  document.addEventListener("DOMContentLoaded", initHomePage);
  document.addEventListener("shopify:section:load", initHomePage);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"]) return;
  try {
    
  
  function initLookbook(){

    // Toggle caption on hover
    var images = document.querySelectorAll('.lookbook-image-wrap * > img')
    
    images.forEach(function(img){
      img.addEventListener('mouseenter', function(e){
        
        var caption = e.target.closest('.lookbook-image-wrap').querySelector('.lookbook-image-caption')
        if(caption)
          caption.classList.add('lookbook-image-caption-show')
      })
      img.addEventListener('mouseleave', function(e){
        var caption = e.target.closest('.lookbook-image-wrap').querySelector('.lookbook-image-caption')
        
        if(caption)
          caption.classList.remove('lookbook-image-caption-show')
      })
    })
  }
  document.addEventListener("DOMContentLoaded", initLookbook);
  document.addEventListener("shopify:section:load", initLookbook);
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  
  function initBlogPost(){
    return console.log('init blog post')
    // TODO: infinite scroll blog posts
  }
  document.addEventListener("DOMContentLoaded", initBlogPost);
  document.addEventListener("shopify:section:load", initBlogPost);
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-menu"]) return;
  try {
    

  function initMenu(){
    
    var menu = document.getElementById('menu')
    var cartlink = document.getElementById('cartlink')
    var menuToggle = document.getElementById('menu-toggle')
    
    menuToggle.addEventListener('click', function(e){
      menuToggle.classList.toggle('menu--toggle-active')
      menu.classList.toggle('menu-active')
      console.log(cartlink.classList.contains('home'))
      if(cartlink.classList.contains('home'))
        cartlink.classList.toggle('home-visible')
    })

    var bar = document.getElementById('preview-bar-iframe')
    if(bar) bar.remove()
  }

  function initCountrySelector(){
    var countrySelector = document.querySelector('#country-selector select')
    var form = document.querySelector('#country-selector form')
    if(!form || !countrySelector) return console.log('no form or country selector')
    countrySelector.addEventListener('change', function(e){
      form.submit()
    })
  }

  function init(){
    initMenu()
    initCountrySelector()
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);



// Navbar Dropdown code
document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.nav-dropdown');

  dropdowns.forEach((dropdown) => {
    const toggleButton = dropdown.querySelector('.nav-dropdown_arrow');
    const dropdownMenu = dropdown.querySelector('.nav-dropdown_menu');

    const closeDropdown = () => {
      if (dropdownMenu.style.height !== '0px' && dropdownMenu.style.height !== '') {
        dropdownMenu.style.height = dropdownMenu.scrollHeight + 'px';

        requestAnimationFrame(() => {
          dropdownMenu.style.height = '0px';
        });

        toggleButton.classList.remove('active');
      }
    };

    const toggleDropdown = () => {
      if (dropdownMenu.style.height === '' || dropdownMenu.style.height === '0px') {
        const menuHeight = dropdownMenu.scrollHeight + 'px';
        dropdownMenu.style.height = menuHeight;

        dropdownMenu.addEventListener('transitionend', () => {
          dropdownMenu.style.height = 'auto';
        }, { once: true });

        toggleButton.classList.add('active');
      } else {
        closeDropdown();
      }
    };

    dropdown.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleDropdown();
    });

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown();
      }
    });
  });
});

// Delete link from dropdown toggle
document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.nav-dropdown');

  dropdowns.forEach((dropdown) => {
    const links = dropdown.querySelectorAll(':scope > a');

    links.forEach((link) => {
      link.removeAttribute('href');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
